import { ExportableColumn } from './Exporter';

export const showCollapseRender = <T>(columns: ExportableColumn<T>[]) => {
  if (
    columns.filter((column) => !column.hideInSearch && column.renderFormItem)
      .length === 1
  ) {
    return false;
  } else {
    return undefined;
  }
};
